import 'apps/hiring/styles/components/employee-sidebar.scss';
import React from 'react';
import PropTypes from 'prop-types';
import ProfileSidebarUser from 'apps/hiring/components/profile-sidebar-user';

class EmployeeSidebar extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    loading: PropTypes.bool
  }

  render() {
    const {
      user,
      loading=false
    } = this.props;

    return (
      <div className="hiring-employee-sidebar">
        <ProfileSidebarUser user={user} downloads={[]} loading={loading} />
      </div>
    );
  }
}

export default EmployeeSidebar;
